/** 合并图片处理参数，保留签名及其他查询参数，并将输出格式放在最后。 */
export function getImageProcessUrl(src: string, operation: string): string {
  if (src === '' || src.startsWith('blob:') || src.startsWith('data:')) {
    return src;
  }

  const hashIndex = src.indexOf('#');
  const hash = hashIndex >= 0 ? src.slice(hashIndex) : '';
  const url = hashIndex >= 0 ? src.slice(0, hashIndex) : src;
  const queryIndex = url.indexOf('?');
  const path = queryIndex >= 0 ? url.slice(0, queryIndex) : url;
  const params = new URLSearchParams(queryIndex >= 0 ? url.slice(queryIndex + 1) : '');
  if (!params.has('x-oss-process')) {
    return `${url}${queryIndex >= 0 ? '&' : '?'}x-oss-process=image/${operation}${hash}`;
  }
  const [name] = operation.split(',');
  const operations = (params.get('x-oss-process') ?? 'image').split('/')
    .filter(item => !item.startsWith(`${name},`));
  operations.push(operation);

  const format = operations.find(item => item.startsWith('format,'));
  const result = operations.filter(item => !item.startsWith('format,'));
  if (format != null) {
    result.push(format);
  }
  params.set('x-oss-process', result.join('/'));

  return `${path}?${params.toString()}${hash}`;
}

/** OSS 对象可能没有扩展名或标错 MIME，仅在实际格式为 HEIC/HEIF 时提供 JPEG 地址。 */
export async function getHeicFallback(src: string): Promise<string | undefined> {
  if (src === '' || src.startsWith('blob:') || src.startsWith('data:')) {
    return;
  }
  try {
    const url = new URL(src, window.location.href);
    if (url.searchParams.get('x-oss-process')?.includes('format,jpg') === true) {
      return;
    }
    url.searchParams.set('x-oss-process', 'image/info');
    const response = await fetch(url.toString());
    if (!response.ok) {
      return;
    }
    const info = await response.json() as { Format?: { value?: string } };
    if (/^(heic|heif)$/i.test(info.Format?.value ?? '')) {
      return getImageProcessUrl(src, 'format,jpg');
    }
  } catch {
    // 格式探测失败时保留原图兜底。
  }
}
